import { useCallback } from "react";

import { useMutationWithToaster } from "hooks";

export function useInstallTemplate(onDone = () => {}) {
  const mutationFactory = useCallback(() => {
    const query = `mutation installTemplate($releaseId: ID!) {
      installTemplate(releaseId: $releaseId) {
        process {
          uuid
          workflows {
            edges {
              node {
                uuid
                name
                numTasks
                numActiveClients
                numActiveClientWorkflows
                hasWorkflowRules
                isNewTemplate
                canEdit
                clientTileOptions {
                  showProgress
                  showIcons
                  showStreams
                  numberOfTasks
                  presentWorkflowName
                  presentStartDate
                }
                process {
                  uuid
                  color
                  name
                }
              }
            }
          }

        }
      }
    }`;

    const resolver = ({ errors, data }) => {
      if (errors && errors.length) {
        return { errors: errors };
      }

      const { uuid, workflows } = data.installTemplate.process;
      return {
        data: {
          id: uuid,
          workflows: workflows.edges.map(({ node }) => {
            return { ...node, id: node.uuid };
          }),
        },
      };
    };

    return { query, resolver };
  }, []);

  const [install, { loading }] = useMutationWithToaster(mutationFactory, {
    onDone: useCallback(onDone, []),
  });

  return { install: install, installing: loading };
}

export default useInstallTemplate;
